<!-- @format -->

<sis-expandable [level]="level" [title]="'STUDIES.COURSE_UNIT_INFO_MODAL.COURSE_UNIT_SUBSTITUTIONS' | transloco" [closed]="false">
  <ng-template sisExpandableContent>
    @if (courseUnit.substitutions?.length > 0 || courseUnit.equivalentCoursesInfo) {
      @if (!hasValidatablePlan) {
        <div role="heading" [attr.aria-level]="level" class="fudis-heading__lg">
          {{ "STUDIES.COURSE_UNITS_BASICINFO.SUBSTITUTIONS" | transloco }}
        </div>
      }
      @if (hasValidatablePlan) {
        <p><transloco key="{{ 'STUDIES.COURSE_UNIT_INFO_MODAL.SUBSTITUTE_INFORMATION' }}"></transloco></p>
      }
    }
    <div class="row">
      <div class="col-12 col-md-6">
        @if (courseUnit.substitutions?.length > 0 || courseUnit.equivalentCoursesInfo) {
          <div class="form-group-mimic">
            <div role="heading" [attr.aria-level]="level + 1" class="fudis-heading__md">{{
              "STUDIES.COURSE_UNIT_INFO_MODAL.SUBSTITUTE_SUBTITLE" | transloco
            }}</div>
            @for (substitution of courseUnit.substitutions; track substitution; let substitutionIndex = $index) {
              <div class="substitution">
                @if (hasValidatablePlan) {
                  <legend class="sis-label">
                    {{ ("STUDIES.COURSE_UNIT_INFO_MODAL.SUBSTITUTIONS_OPTION" | translate) + " " + (substitutionIndex + 1) }}
                  </legend>
                  <sis-course-unit-substitution
                    [substitution]="substitution"
                    [colorIndex]="substitutionIndex"
                    [language]="contentLanguage"
                    (openCourseUnitModalEvent)="openCourseUnitModalEvent.emit($event)">
                  </sis-course-unit-substitution>
                }
                @if (!hasValidatablePlan) {
                  <sis-course-unit-substitution [substitution]="substitution" [colorIndex]="substitutionIndex" [language]="contentLanguage">
                  </sis-course-unit-substitution>
                }
              </div>
            }
            <div class="equivalent-courses-info">
              <sis-localized-markup-string-view [content]="courseUnit.equivalentCoursesInfo"></sis-localized-markup-string-view>
            </div>
          </div>
        }
        @if (courseUnit.substitutions?.length === 0 && !courseUnit.equivalentCoursesInfo) {
          <div class="form-group-mimic">
            <p class="sis-guidance"> {{ "STUDIES.COURSE_UNIT_INFO_MODAL.NO_SUBSTITUTIONS" | transloco }}</p>
          </div>
        }
      </div>
    </div>
  </ng-template>
</sis-expandable>
